module.exports = __webpack_public_path__ + "img/Product_trading_stock.61b6fb0b.svg";